import TelegramLoginButton, { TelegramUser } from 'telegram-login-button'
import React, { useCallback, useState } from 'react'
import axios from 'axios'
import { useUser } from '../context'
import { BASE_API_URL } from '../constants'
import { useNavigate } from 'react-router'
import { Footer } from '../components'

const HowItWorks = () => {
	return (
		<div style={{ marginTop: 26, marginBottom: 96 }}>
			<div style={{ display: 'flex', justifyContent: 'center' }}>
				<h2
					style={{
						fontSize: 24,
						marginBottom: 54,
					}}
				>
					How It{' '}
					<span
						style={{
							color: 'rgb(212 175 55 / .8)',
						}}
					>
						Works
					</span>
				</h2>
			</div>

			<div className="how-it-works-container">
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
					}}
					className="how-item"
				>
					<div
						className="icon-circle"
						style={{
							background: 'rgb(51, 144, 236)',
						}}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							<path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
						</svg>
					</div>

					<span className="title">Sign up via Telegram</span>
					<span className="subscript">
						Connect with your Telegram account for secure
						authentication and communication.
					</span>
				</div>

				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
					}}
					className="how-item"
				>
					<div
						className="icon-circle"
						style={{
							background: 'rgb(168, 85, 247)',
						}}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
							className="lucide lucide-wallet w-8 h-8"
						>
							<path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path>
							<path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path>
						</svg>
					</div>

					<span className="title">Deposit & Withdraw Funds</span>
					<span className="subscript">
						Easily deposit funds to start earning or withdraw
						anytime you want.
					</span>
				</div>

				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
					}}
					className="how-item"
				>
					<div
						className="icon-circle"
						style={{
							background: 'rgb(212, 175, 55)',
						}}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							<polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
							<polyline points="16 7 22 7 22 13"></polyline>
						</svg>
					</div>

					<span className="title">Earn APY on Autopilot</span>
					<span className="subscript">
						Agent Jeeves will optimize your yields and confirm
						actions before taking them.
					</span>
				</div>
			</div>
		</div>
	)
}

export const Landing = () => {
	let navigate = useNavigate()
	const { user, setUser } = useUser()
	const [isProcessing, setProcessing] = useState(false)

	console.log(user, isProcessing)

	const onTgAuth = useCallback(
		async (tgUser: TelegramUser) => {
			setProcessing(true)

			try {
				const { data } = await axios.post(
					`${BASE_API_URL}/api/jeeve/tg-login`,
					tgUser,
				)
				setUser({
					// @ts-expect-error: last_name is returned but the package used has outdated typings
					tgMetadata: tgUser,
					dbInfo: data,
				})
			} catch (error) {
				console.log(error)
				// TODO: show toast here
			} finally {
				setProcessing(false)
			}
		},
		[setUser],
	)

	return (
		<div>
			<div
				style={{
					height: '70vh',
					background: 'rgb(12 14 18)',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					padding: 96,
				}}
			>
				<img
					style={{
						height: 200,
					}}
					src="/jeeve-headshot.png"
					alt="Agent Jeeve mascot"
				/>
				<h1
					style={{
						color: 'rgb(212 175 55 / .8)',
						fontSize: 60,
						marginTop: 30,
						marginBottom: 20,
					}}
				>
					Agent Jeeves
				</h1>
				<h2 style={{ fontSize: 24, marginBottom: 48 }}>
					Your AI Butler for{' '}
					<span style={{ color: 'rgb(212 175 55 / .8)' }}>
						Max Yield Farming
					</span>
				</h2>

				{/* TODO: remove the button */}
				{/*<button
					onClick={() => {
						setUser({
							tgMetadata: {
								id: 1774568685,
								first_name: 'Akarsh',
								last_name: 'Sachdeva',
								username: 'akproio',
								auth_date: 1743561065,
								hash: '0ec03f8712916201c52457960a0b823a678694d044d867961b6ba4e752b82d26',
							},
							dbInfo: {
								tradingPrefs: {
									maxTradeAmount: 88,
								},
								name: 'Akarsh Sachdeva',
								createdAt: '2025-03-26T05:15:18.515Z',
								updatedAt: '2025-03-26T06:59:35.658Z',
								id: '67e38d66e46eef22f916d451',
								address:
									'0x79b71674966206DCC09f9311457D5820bF29b592',
							},
						})
					}}
				>
					dev:set_user
				</button>
				<button
					className="theme-yellow-button"
					onClick={() => {
						navigate('/dashboard')
					}}
				>
					Go to Dashboard
				</button>*/}

				{user?.dbInfo?.id ? (
					<button
						className="theme-yellow-button"
						onClick={() => {
							navigate('/dashboard')
						}}
					>
						Go to Dashboard
					</button>
				) : (
					<TelegramLoginButton
						botName="bbcredlogintestbot"
						dataOnauth={onTgAuth}
					/>
				)}
			</div>

			<HowItWorks />

			<Footer />
		</div>
	)
}
